<template>
  <div>
    <header id="hero" class="hero stars">
      <header id="nav" class="nav">
        <nav class="container w-container">
          <a href="#learnmore" class="button-3 button-sm trans w-button w--current">
            <strong>Learn more</strong>
          </a>
          <a href="#packages" class="button-3 button-sm white w-button">
            <strong>Go viral!</strong>
          </a>
        </nav>
      </header>
      <div class="flex-container w-container">
        <div>
          <h1 class="heading-1">Followers that boost your account to the next level</h1>
          <p class="paragraph">Grow your TikTok account quickly and cheap with our reliable service. Build a real audience and show your videos to thousands of people!</p>
          <a href="#learnmore" class="button-3 button-sm trans w-button w--current">
            <strong>Learn more</strong>
          </a>
          <a href="#packages" class="button-3 w-button">Grow now</a>
        </div>
        <div class="hero-image-mask right">
          <img src="@/assets/growth.png" alt class="hero-image" />
        </div>
      </div>
    </header>
    <div id="packages" class="hero white">
      <div class="flex-container w-container">
        <div class="columns w-row">
          <div class="w-col w-col-4">
            <div class="buyoption">
              <div class="w-form">
                <form id="email-form" name="email-form" data-name="Email Form">
                  <select v-model="views" id="field" name="field" class="select-field w-select">
                    <option value="1000 views">1000 views - $ 1.99</option>
                    <option value="2000 views">2000 views - $ 3.99</option>
                    <option value="5000 views">5000 views - $ 7.99</option>
                    <option value="10000 views">10000 views - $ 11.99</option>
                    <option value="20000 views">20000 views - $ 13.99</option>
                  </select>
                  <a href="#" @click="confirmViews()" class="button-3 small w-button">Buy TikTok&nbsp;Views</a>
                </form>
              </div>
              <ul>
                <li>
                  <i class="fas fa-check"></i> Quality followers
                </li>
                <li>
                  <i class="fas fa-check"></i> Deliver
                  <strong>&lt; 24h</strong>
                </li>
                <li>
                  <i class="fas fa-check"></i> 24/7 support
                </li>
              </ul>
            </div>
          </div>
          <div class="w-col w-col-4">
            <div class="buyoption larger">
              <span class="sale">-40%</span>
              <div class="w-form">
                <form id="email-form" name="email-form" data-name="Email Form">
                  <select v-model="followers" id="field-2" name="field-2" data-name="Field 2" class="select-field w-select">
                    <option value="100 followers">100 followers - $ 1.99</option>
                    <option value="500 followers">500 followers - $ 8.99</option>
                    <option value="1000 followers">1000 followers - $ 14.99</option>
                    <option value="2500 followers">2500 followers - $ 29.99</option>
                    <option value="5000 followers">5000 followers - $ 39.99</option>
                  </select>
                  <a href="#" @click="confirmFollowers()" class="button-3 small w-button">Buy TikTok&nbsp;Followers</a>
                </form>
              </div>
              <ul>
                <li>
                  <i class="fas fa-check"></i> Quality followers
                </li>
                <li>
                  <i class="fas fa-check"></i> Deliver
                  <strong>&lt; 24h</strong>
                </li>
                <li>
                  <i class="fas fa-check"></i> 24/7 support
                </li>
              </ul>
            </div>
          </div>
          <div class="w-col w-col-4">
            <div class="buyoption">
              <div class="w-form">
                <form id="email-form" name="email-form" data-name="Email Form">
                  <select v-model="likes" id="field-3" name="field-3" data-name="Field 3" class="select-field w-select">
                    <option value="100 likes">100 likes - $ 1.99</option>
                    <option value="500 likes">500 likes - $ 8.99</option>
                    <option value="1000 likes">1000 likes - $ 14.99</option>
                    <option value="2500 likes">2500 likes - $ 29.99</option>
                    <option value="5000 likes">5000 likes - $ 39.99</option>
                  </select>
                  <a href="#" @click="confirmLikes()" class="button-3 small w-button">Buy TikTok&nbsp;Likes</a>
                </form>
              </div>
              <ul>
                <li>
                  <i class="fas fa-check"></i> Quality followers
                </li>
                <li>
                  <i class="fas fa-check"></i> Deliver
                  <strong>&lt; 24h</strong>
                </li>
                <li>
                  <i class="fas fa-check"></i> 24/7 support
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="learnmore" class="hero-2 hero gray">
      <div class="flex-container w-container">
        <div class="hero-image-mask left">
          <img src="@/assets/notification.png" alt class="hero-image" />
        </div>
        <div>
          <h5 class="heading-2">HOW IT WORKS</h5>
          <h1 class="heading-3">
            Grow your TikTok
            <span class="text-span">instantly</span>
          </h1>
          <p class="paragraph">We will send real views, followers or likes to your account or video within our delivery time of 24 hours. These followers will allow you to boost your account and build a bigger audience.</p>
          <a href="#packages" class="button-3 white w-button">
            <strong>See options</strong>
          </a>
        </div>
      </div>
    </div>
    <div class="hero-2 hero white">
      <div class="flex-container w-container">
        <div class="left">
          <h5 class="heading-2">WHY CHOOSE US</h5>
          <h1 class="heading-3">
            Why choose
            <span class="text-span">GrowingTikTok.com</span>
          </h1>
          <p class="paragraph">
            GrowingTikTok.com has helped
            <strong class="text-span">thousands</strong> of happy clients grow their accounts on demand. Not everybody has the time or skills to reach many people. We can help with that.
          </p>
          <a href="#packages" class="button-3 w-button">
            <strong>See options</strong>
          </a>
        </div>
        <div class="hero-image-mask">
          <img src="@/assets/notification.png" alt class="hero-image" />
        </div>
      </div>
    </div>
    <header id="faq" class="hero-2 hero blue">
      <div class="w-container">
        <h1 class="heading-5">Frequently asked questions</h1>
        <blockquote>How long will my order take?</blockquote>
        <div>
          We will deliver all orders within 24 hours.
          <br />‍
        </div>
        <blockquote>Is this safe?</blockquote>
        <div>
          Yes, it is safe for you to use your sevice to grow your account. We have never heard of banned accounts after using our services.
          <br />‍
        </div>
      </div>
    </header>
    <section id="call-to-action" class="call-to-action">
      <div class="centered-container w-container">
        <h2>
          Ready to grow instantly?
          <br />‍
        </h2>
        <a href="#packages" class="button-3 w-button">Grow now!</a>
      </div>
    </section>
    <footer id="footer" class="footer">
      <img src="@/assets/logo.png" style="max-width: 100px" />
      <br />
      <br />
      <div class="w-container">
        <strong>
          <div class="text-block-3">© GrowingTikTok.com</div>
        </strong>
      </div>
    </footer>
  </div>
</template>
<script>
import axios from "axios"
import { loadStripe } from "@stripe/stripe-js"

export default {
  data() {
    return {
      stripe: null,
      views: "1000 views",
      followers: "100 followers",
      likes: "100 likes",
    }
  },
  async mounted() {
    // this.stripe = await loadStripe("pk_test_VWeUkFnLjT1vzBnxTJZa1tLF00zjdOsmuL")
    this.stripe = await loadStripe("pk_live_rhTgI9ICqGeCmxbK8werkmOh00I65yO5G8")
  },
  methods: {
    confirmViews() {
      this.$buefy.dialog.prompt({
        message: `Give the link to the TikTok video`,
        trapFocus: true,
        onConfirm: (data) => this.buy(data, this.views),
      })
    },
    confirmFollowers() {
      this.$buefy.dialog.prompt({
        message: `Give the link to your TikTok account`,
        trapFocus: true,
        onConfirm: (data) => this.buy(data, this.followers),
      })
    },
    confirmLikes() {
      this.$buefy.dialog.prompt({
        message: `Give the link to the TikTok video`,
        trapFocus: true,
        onConfirm: (data) => this.buy(data, this.likes),
      })
    },
    buy(data, item) {
      axios.post("https://api.growingtiktok.com/payment", { data, item }).then((response) => {
        this.stripe
          .redirectToCheckout({
            // Make the id field from the Checkout Session creation API response
            // available to this file, so you can provide it as parameter here
            // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
            sessionId: response.data.session,
          })
          .then(function (result) {
            console.log(result)
          })
      })
    },
  },
}
</script>
<style lang="scss">
.hero {
  font-family: "Ubuntu" !important;
}
.dialog {
  .button {
    padding: 0 !important;
  }
}
.paragraph {
  font-size: 140%;
  line-height: 1.5;
}
.sale {
  color: #5d53ff;
  font-size: 25px;
  font-weight: bold;
  display: block;
  margin-bottom: 20px;
}
#packages {
  background-image: linear-gradient(180deg, #5d53ff 0%, #e056fd 100%) !important;
}
#faq {
  clip-path: polygon(80% 0%, 100% 20%, 100% 100%, 0% 100%, 0% 20%);
  padding-top: 150px;
}
</style>